module.exports = __webpack_public_path__ + "img/yuni-congratulations.8d50fa8d.png";